module.exports = "/be196c01d3307b3428e4bce6276438b2.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/images/feature-1.png
 ** module id = 2211
 ** module chunks = 0
 **/